




























import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { navigateTo } from '@/router'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      handleGoodsClick = (id: string) => {
        navigateTo('GoodsIndex', { id })
      }
    },
)
